<!--充电机数据 -->
<template>
  <div id="charges" style="background: #fff;">
    <div id="search" class="filter-container" style="padding-left:20px;">
      <el-input v-model="listQuery.sn" clearable placeholder="sn" class="input-with-select deviceNameTable" @clear="searchTable">
        <el-button slot="append" icon="el-icon-search" @click="searchTable" />
      </el-input>
      <div style="float: right;margin: 13px 20px 0;">
        <el-button class="filter-item" type="primary" icon="el-icon-upload2" style="margin-top: -2px;margin-bottom: 0;" @click="uploadVersion" />
      </div>
    </div>

    <el-dialog :close-on-click-modal="false" :visible.sync="uploadFileDialog">
      <el-form label-position="left" label-width="130px" style="width: 400px; margin-left:50px;">
        <el-form-item label="File Name">
          <el-upload ref="upload" class="upload-demo" action="" :on-change="handleChange" :file-list="fileList" :auto-upload="false">
            <el-button slot="trigger" size="small" type="primary" :loading="uploading">{{ $t('QR.SelectFile') }}</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('QR.ForExample')">
          03006722.xlsx
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="uploadFileDialog = false">{{ $t('button.Cancel') }}</el-button>
        <el-button type="primary" :disabled="fileList.length==0" @click="uploadFileSubmit">{{ $t('button.Submit') }}</el-button>
      </div>
    </el-dialog>
    <div class="app-container" style="padding-top:0;">
      <el-table id="chargesTable" v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="auto" class="demo-table-expand">
              
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Track')">
                  <span>{{ scope.row.barCode }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.FirmwareVersion')">
                  <span>{{ scope.row.firmwareVersion }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.PCBVersion3')">
                  <span>{{ scope.row.pcbV3 }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.PCBVersion6')">
                  <span>{{ scope.row.pcbV6 }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.CustomerNum')">
                  <span>{{ scope.row.customerArticleNumber }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.OrderDate')">
                  <span>{{ scope.row.orderDate }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.ActivationDate')">
                  <span>{{ scope.row.activityDate }}</span>
                </el-form-item>

              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.SalesTicket')">
                  <span>{{ scope.row.saleno }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.PCBVersion1')">
                  <span>{{ scope.row.pcbV1 }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.PCBVersion4')">
                  <span>{{ scope.row.pcbV4 }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.ChargProfile')">
                  <span>{{ scope.row.chargingCurve }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.CustomerCode')">
                  <span>{{ scope.row.customerSn }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.orderTicket')">
                  <span>{{ scope.row.customerOrder }}</span>
                </el-form-item>
                <el-form-item :label="$t('QR.warrantyperiod')">
                  <span>{{ scope.row.warrantyDate }}</span>
                </el-form-item>

              </el-col>
              <el-col :xs="12" :sm="12" :lg="8">
                <el-form-item :label="$t('adminView.Name')">
                  <span>{{ scope.row.proName }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.PCBVersion2')">
                  <span>{{ scope.row.pcbV2 }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.PCBVersion5')">
                  <span>{{ scope.row.pcbV5 }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.Certification')">
                  <span>{{ scope.row.auth }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.CustomerName')">
                  <span>{{ scope.row.customerName }}</span>
                </el-form-item>
                <el-form-item :label="$t('QR.Dateofmanufacture')">
                  <span>{{ scope.row.makeDate }}</span>
                </el-form-item>
                <el-form-item :label="$t('adminView.QRPath')">
                  <span>{{ scope.row.qrUrl }}</span>
                </el-form-item>


              </el-col>

            </el-form>
          </template>
        </el-table-column>
        <el-table-column :label="$t('BondOrUpdateDevice.SN')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.sn }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.ProductID')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.proCode }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('QR.Dateofmanufacture')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.makeDate }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="edit(scope.row)">
              {{ $t('adminView.Edit') }}
            </el-button>
            <el-button v-if="scope.row.bind" type="text" size="small" @click.native.prevent="showBind(scope.row)">
              {{ $t('adminView.Bonded') }}
            </el-button>
            <el-button v-else type="text" size="small" @click.native.prevent="showBind(scope.row)">
              {{ $t('adminView.NotBonded') }}
            </el-button>

            <!-- 蓝牙记录 -->
            <el-button type="text" size="small" @click.native.prevent="toRecord(scope.row)">
              {{$t('charger.ble_record')}}
            </el-button>

            <!-- 二维码连接 -->
            <el-button title="二维码连接" type="text" icon="el-icon-view" size="small" @click="viewUrl(scope.row)"> </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

      <!-- 绑定公司--弹窗 -->
      <div>
        <el-dialog :close-on-click-modal="false" :title="$t('adminView.BondCompanyInfo')" :visible.sync="bindDialog">
          <el-form id="bindCompany" ref="bindCompany" :model="bind" :rules="popRule" label-width="200px" class="demo-form-inline">
            <el-form-item :label="$t('adminView.Region')">
              <el-select v-model="bind.region" :placeholder="$t('button.select')" @change="regionSelect">
                <el-option v-for="item in regionsOption" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('adminView.CompanyInfo')" prop="company">
              <el-input v-model="bind.company" />
            </el-form-item>
            <el-form-item :label="$t('adminView.ContactPerson')">
              <el-input v-model="bind.contacts" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Tel')">
              <el-input v-model="bind.phone" />
            </el-form-item>
            <el-form-item :label="$t('company.Email')">
              <el-input v-model="bind.email" />
            </el-form-item>
            <el-form-item :label="$t('adminView.WarrantyDate')" prop="warranty">
              <!-- <el-input v-model="bind.warranty" /> -->
              <el-date-picker v-model="bind.warranty" type="date" :placeholder="$t('location.pleaseSelectDate')" />
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="bindDialog = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitBind('bindCompany')">{{ $t('button.Submit') }}</el-button>
          </div>
        </el-dialog>
      </div>

      <!-- 编辑--弹窗 -->
      <div>
        <el-dialog :close-on-click-modal="false" :title=" $t('adminView.Edit')" :visible.sync="editFormDialog" width="80%">
          <el-form ref="dataForm" :inline="true" :model="dataModel" label-width="200px" class="demo-form-inline editPop">
            <el-form-item :label="$t('BondOrUpdateDevice.SN')">
              <el-input v-model="dataModel.sn" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Track')">
              <el-input v-model="dataModel.barCode" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('adminView.SalesTicket')">
              <el-input v-model="dataModel.saleno" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('QR.ProductID')" :disabled="true">
              <el-input v-model="dataModel.proCode" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Name')">
              <el-input v-model="dataModel.proName" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('adminView.FirmwareVersion')">
              <el-input v-model="dataModel.firmwareVersion" />
            </el-form-item>
            <el-form-item :label="$t('QR.Dateofmanufacture')">
              <el-date-picker v-model="dataModel.makeDate" type="date" :placeholder="$t('location.pleaseSelectDate')" style="width: 100%;" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('adminView.PCBVersion1')">
              <el-input v-model="dataModel.pcbV1" />
            </el-form-item>
            <el-form-item :label="$t('adminView.PCBVersion2')">
              <el-input v-model="dataModel.pcbV2" />
            </el-form-item>
            <el-form-item :label="$t('adminView.PCBVersion3')">
              <el-input v-model="dataModel.pcbV3" />
            </el-form-item>
            <el-form-item :label="$t('adminView.PCBVersion4')">
              <el-input v-model="dataModel.pcbV4" />
            </el-form-item>
            <el-form-item :label="$t('adminView.PCBVersion5')">
              <el-input v-model="dataModel.pcbV5" />
            </el-form-item>
            <el-form-item :label="$t('adminView.PCBVersion6')">
              <el-input v-model="dataModel.pcbV6" />
            </el-form-item>
            <el-form-item :label="$t('adminView.ChargProfile')">
              <el-input v-model="dataModel.chargingCurve" />
            </el-form-item>
            <el-form-item :label="$t('adminView.Certification')">
              <el-input v-model="dataModel.auth" />
            </el-form-item>
            <el-form-item :label="$t('adminView.CustomerNum')">
              <el-input v-model="dataModel.customerArticleNumber" />
            </el-form-item>
            <el-form-item :label="$t('adminView.CustomerCode')">
              <el-input v-model="dataModel.customerSn" />
            </el-form-item>
            <el-form-item :label="$t('adminView.CustomerName')">
              <el-input v-model="dataModel.customerName" />
            </el-form-item>
            <el-form-item :label="$t('adminView.OrderDate')">
              <!-- <el-input v-model="dataModel.orderDate" /> -->
              <el-date-picker v-model="dataModel.orderDate" type="date" :placeholder="$t('location.pleaseSelectDate')" />
            </el-form-item>
            <el-form-item :label="$t('adminView.orderTicket')">
              <el-input v-model="dataModel.customerOrder" />
            </el-form-item>

            <el-form-item :label="$t('adminView.ActivationDate')">
              <el-date-picker v-model="dataModel.activityDate" type="date" :placeholder="$t('location.pleaseSelectDate')" />
            </el-form-item>

            <el-form-item :label="$t('QR.warrantyperiod')">
              <el-date-picker v-model="dataModel.warrantyDate" type="date" :placeholder="$t('location.pleaseSelectDate')" style="width: 100%;" />
            </el-form-item>
            <el-form-item :label="$t('adminView.QRPath')">
              <el-input v-model="dataModel.qrUrl" />
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="editFormDialog = false">{{ $t('button.Cancel') }}</el-button>
            <el-button type="primary" @click="submitForm">{{ $t('button.Submit') }}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { pageList, importExcel, updateDeviceQrData, bindCharger } from '@/api/QR'
import { pagination } from '@/utils/init_table'
import { timeStamp2String } from '@/utils/index'
import i18n from '@/i18n'

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      list: null,
      listLoading: true,
      listQuery: {
        chargerSn: null,
        pageInfo: pagination()
      },
      dialogStatus: '',
      dataModel: {
        sn: null,
        barCode: null,
        saleno: null,
        proCode: null,
        proModule: null,
        proName: null,
        firmwareVersion: null,
        makeDate: null,
        pcbV1: null,
        pcbV2: null,
        pcbV3: null,
        pcbV4: null,
        pcbV5: null,
        pcbV6: null,
        chargingCurve: null,
        auth: null,
        customerArticleNumber: null,
        customerSn: null,
        customerName: null,
        orderDate: null,
        customerOrder: null,
        activityDate: null,
        warrantyDate: null,
        qrUrl: null,
        id: null
      },
      editFormDialog: false,
      bindDialog: false,
      bind: {
        sn: null,
        company: null,
        email: null,
        md: 1525708800000,
        phone: '',
        region: 'OTHERS',
        warranty: ''
      },
      popRule: {
        company: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }],
        warranty: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }]
      },
      regionsOption: [
        'AUSTRALIA',
        'CANADA',
        'CHINA',
        'EUROPE',
        'HK/MACAU',
        'JAPAN',
        'KOREA',
        'MEXICO',
        'MIDDLE-EAST',
        'OTHERS',
        'SINGAPORE',
        'TAIWAN',
        'TURKEY',
        'US',
        'VIETNAM'
      ],
      fileList: [],
      uploadFileDialog: false,
      uploading: false,
      value: 8
    }
  },
  created() {
    this.queryList()
  },
  methods: {
    viewUrl (row) {
      open(`http://www.scanmi.net/d/01/?sn=${row.sn}&m=${row.proCode}`)
    },
    toRecord (row) {
      console.log(row)
      this.$router.push({path: '/blueTooth/chargeDataDetail?chargerSn='+ row.sn})
    },
    queryList() {
      this.listLoading = true
      // console.log(this.listQuery)
      var param = {
        companyIdList: [],
        sn: this.listQuery.sn,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      pageList(param).then(response => {
        this.list = response.resultModel.list
        this.list.forEach(v => {
          if (v.orderDate)v.orderDate = v.orderDate.split('T')[0]
          if (v.makeDate)v.makeDate = v.makeDate.split('T')[0]
          if (v.activityDate)v.activityDate = v.activityDate.split('T')[0]
          if (v.warrantyDate)v.warrantyDate = v.warrantyDate.split('T')[0]
        })
        this.listQuery.pageInfo.total = response.resultModel.total
        this.listLoading = false
      })
    },
    uploadVersion() { // 上传
      this.uploadFileDialog = true
    },
    handleChange(file, fileList) { // 上传弹窗
      this.fileList.push(file)
      this.$refs.upload.clearFiles()
    },
    uploadFileSubmit() { // 上传文件弹窗--提交
      this.uploading = true
      var file = this.fileList.pop()
      // console.log('file--', file)
      importExcel(file, this.value).then(response => {
        if (response.resultCode == 1001) {
          this.uploadFileDialog = false
          // this.list = response.list
          this.$notify({
            title: '',
            message: i18n.t('lease.Succeed'),
            type: 'success',
            duration: 2000
          })
          this.queryList()
          this.uploading = false
        } else {
          var msg = i18n.t('lease.Failed')
          if (response.resultMessage.indexOf('解析错误') > -1) {
            msg = i18n.t('QR.contentError')
          }
          this.$notify({
            title: '',
            message: msg,
            type: 'error',
            duration: 2000
          })
          this.uploading = false
        }
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange(val, e) {
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    selectChange(selection) {
      this.itemIds = selection
    },
    submitForm() {
      updateDeviceQrData(this.dataModel).then(response => {
        this.editFormDialog = false
        this.queryList()
        this.$notify({
          title: '',
          message: i18n.t('lease.Succeed'),
          type: 'success',
          duration: 2000
        })
      })
    },

    formatTime(s) {
      return timeStamp2String(s)
    },
    edit(data) {
      for (var key in data) {
        this.dataModel[key] = data[key]
      }
      this.editFormDialog = true
    },
    showBind(data) {
      if (data.bind) {
        this.bind = data.bind
      } else {
        this.bind = {
          sn: data.sn,
          company: null,
          email: null,
          md: data.makeDate,
          phone: '',
          region: 'OTHERS',
          warranty: ''
        }
        this.bind.warranty = data.warrantyDate
        // var makeDates = Date.now() - new Date(data.makeDate).getTime()
        // if (makeDates < 6 * 30 * 24 * 60 * 60 * 1000) { // 当前距离生产日期6个月内
        //   this.bind.warranty = new Date(Date.now() + 13 ** 30 * 24 * 60 * 60 * 1000)
        // }else{
        //   this.bind.warranty = new Date(Date.now() + 13 ** 30 * 24 * 60 * 60 * 1000)
        // }
      }
      this.bindDialog = true
    },
    submitBind(formName) {
      console.log(this.bind)
      // this.bind.warranty
      var regTime = /^(\d{4})-(0\d{1}|1[0-2])-(0\d{1}|[12]\d{1}|3[01])$/
      // if (!regTime.test(this.bind.warranty)) {
      //   alert('时间格式不正确')
      //   return
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          bindCharger(this.bind).then(res => {
            console.log(res)
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: i18n.t('warningSet.submitted')
              })
              this.queryList()
            }
          })
          this.bindDialog = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    regionSelect(query) {
      for (const key2 in this.regionsOption) {
        const region = this.options[key2]
        console.log(region)
      }
    }
  }
}
</script>
<style lang="scss">
#chargesTable{
  .demo-table-expand {
    padding-left: 20px;
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .el-table__expand-column{
    border-right:none;
  }
}
#bindCompany{
  .el-input{
    width:80%;
  }
  .el-select{
    width:100%;
  }
}
#charges{
  #search .el-input-group {
    width: 40%!important;
    max-width: 300px!important;
    margin-top: 13px;
  }
}
.editPop{
  .el-form-item--medium .el-form-item__content{
    width: 240px;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width:100%;
  }
}
</style>